import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetMoneyPage as GetMoneyPageQuery,
    GetMoneyPage_maUrl as MoneyPage,
    GetMoneyPageVariables as GetMoneyPageVariables,
} from 'nutshell-graphql-types';

import GET_MONEY_PAGE from '../queries/get-money-page.graphql';

export const useGetMoneyPage = (
    id: string
): {
    moneyPage: MoneyPage | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetMoneyPageQuery, GetMoneyPageVariables>(
        GET_MONEY_PAGE,
        {
            variables: {
                id,
            },
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        moneyPage: data && data.maUrl,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
